import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbstractServiceOrganization } from './organization.service.abstract';
import { AbstractEndpoints } from '../endpoints/endpoints.service.abstract';
import { ModelOrganization } from '../../models/organizations/organization.model';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';

export class ServiceOrganization implements AbstractServiceOrganization {

  constructor(private endpoints: AbstractEndpoints, private http: HttpClient, private appMonitor: AppMonitoring) { }

  UpdateOrganizations(organizations: ModelOrganization[]): Observable<string> {
    return this.http.post<string>(this.endpoints.organization.updateOrganization, organizations);
  }

}